// _app/immutable/assets/6.60e97f23.css
export default ".button.svelte-1mvhfrc{width:-moz-max-content;width:max-content}\n";